module.exports = __webpack_public_path__ + "static/media/Avatar.ae5cb551.svg";